<template>
  <div>
    <XField
      :errors="validationErrors(formattedLabel)"
      :errorStyle="formFieldsCheckErrorStyle">
      <span
        class="font-medium"
        :style="labelStyle">
        {{ parameters.config.label }}

        <span
          v-if="isOptional"
          class="text-xs font-lighter italic">
          {{ $t('common.formFields.fields.optional') }}
        </span>
      </span>
      <div>
        <XRadio
          color="secondary"
          class="inline-block mr-3"
          :label="$t('common.agreement.yes')"
          :labelStyle="labelStyle"
          :name="parameters.config.id"
          :value="true"
          :data-vv-name="formattedLabel"
          :invalid="validationHasErrors(formattedLabel)"
          v-model="fieldValue"
          v-validate="parameters.required ? 'required' : ''"
          @change="validate" />

        <XRadio
          class="inline-block mr-3"
          color="secondary"
          :label="$t('common.agreement.no')"
          :labelStyle="labelStyle"
          :name="parameters.config.id"
          :value="false"
          :data-vv-name="formattedLabel"
          :invalid="validationHasErrors(formattedLabel)"
          v-model="fieldValue"
          @change="validate" />
      </div>
    </XField>

    <div
      class="mb-2"
      :style="labelStyle">
      <span class="text-sm">{{ message }}</span>
    </div>
    <a
      v-if="parameters.config.url"
      target="_blank"
      class="inline-block mt-2"
      :href="parameters.config.url"
      style="color: black;"
    >
      {{ parameters.config.url }}
    </a>
  </div>
</template>

<script>
import _ from 'lodash'

import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],

  computed: {
    message () {
      return this.fieldValue === null || this.fieldValue === ''
        ? this.parameters.config.options.initialText
        : this.fieldValue === true || this.fieldValue === 'true'
          ? this.parameters.config.options.checkText
          : this.parameters.config.options.denyText
    },

    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    }
  },

  methods: {
    validate () {
      this.$validator.validate(this.formattedLabel)
    }
  }
}
</script>
